module.exports = __webpack_public_path__ + "static/media/logo.6b43a751.png";